module.exports = __webpack_public_path__ + "img/img-1920.74adb27b.jpg";